// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ({"7":"libs/fullcalendar","940":"libs/elastic-apm"}[chunkId] + "." + {"7":"a47399e0e71027440abd","940":"ef3fbd4f8d7c9ae86b2f"}[chunkId] + ".js");